// export const getLocalStorageData = (item: string) => {
//   const localStorageData = JSON?.parse(localStorage?.getItem(item) || "{}");
//   return Object.keys(localStorageData)?.length > 0 ? localStorageData : null;
// };
export const getLocalStorageData = (item: string) => {
  try {
    const storedData = localStorage?.getItem(item);

    if (!storedData) return null;

    const parsedData = JSON.parse(storedData);

    if (typeof parsedData !== "object" || parsedData === null) {
      return parsedData;
    }

    return Object.keys(parsedData).length > 0 ? parsedData : null;
  } catch (error) {
    console.warn(`Error parsing localStorage data for key "${item}":`, error);
    return null;
  }
};

export const setLocalStorageData = (item: string, payload: any) => {
  localStorage.setItem(item, JSON.stringify(payload));
};

export const clearLocalStorageData = () => {
  localStorage.clear();
};

export const removeLocalStorageData = (item: string) => {
  localStorage.removeItem(item);
};
